<template>
  <div class="container-fluid container-lg bg-gray-100 mb-5 p-3">
    <router-link type="button" class="hover:underline block text-left" to="/personal-information">
      <svg
        class="h-8 w-8 fill-current text-blue-900"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="274.835 394.86 54.965 55.15"
      >
        <defs />
        <path
          d="M302.4 395.823c14.752.013 26.694 12.004 26.695 26.805.001 14.592-12.041 26.517-26.753 26.495-14.737-.023-26.754-11.98-26.684-26.551.072-14.873 11.958-26.763 26.742-26.749zm.342 32.534h2.447c3.522 0 7.044.033 10.565-.013 2.327-.03 3.413-1.138 3.479-3.442.039-1.364.033-2.731.003-4.096-.057-2.537-.978-3.536-3.514-3.605-2.801-.076-5.605-.022-8.408-.024-1.471-.001-2.942 0-4.571 0 0-1.899.247-3.457-.079-4.885-.254-1.114-1.01-2.527-1.934-2.949-.783-.357-2.422.2-3.171.899-3.518 3.284-6.88 6.737-10.254 10.171-1.618 1.646-1.652 3.053-.056 4.689 3.413 3.497 6.829 6.997 10.403 10.326.73.68 2.361 1.107 3.203.755.868-.363 1.601-1.754 1.812-2.811.3-1.513.075-3.132.075-5.015z"
        />
      </svg>
    </router-link>
    <div class="container-fluid bg-white rounded-lg p-3 box-shadow">
      <p class="text-gray-700 text-center text-2xl lg:text-3xl">
        Agregar beneficiario para cobertura Accidentes Personales
      </p>

      <form
        autocomplete="off"
        @submit.prevent="onSubmit()"
        class="flex flex-wrap text-left"
      >
        <div
          class="md:container lg:container xl:container lg:w-1/2 xl:w-1/2 lg:pl-48 xl:pl-48 flex flex-wrap"
        >
          <div class="w-full">
            <div>
              <label class="w-full"> Parentesco: </label>
            </div>
            <div>
              <v-select
                :searchable="false"
                v-model="selectedKinship"
                class="w-full shadow-sm appearance-none border rounded text-grey-darker"
                :options="selectKinshipOptions"
                :placeholder="'Seleccione una parentesco'"
                :required="!selectedKinship"
              >
                <template v-slot:no-options>
                  <template> No hay resultados. </template>
                </template>
              </v-select>
              <span v-if="this.errorKinship" class="text-red-600 text-xs"
                >Seleccione una parentesco</span
              >
            </div>
          </div>

          <div class="w-full">
            <div>
              <label class="w-1/2 mt-2"> Apellido Paterno*: </label>
            </div>
            <div>
              <input
                id="input_last_name"
                type="text"
                v-model="paternalLastName"
                class="w-full shadow-sm appearance-none border rounded py-2 px-3 text-grey-darker"
                maxlength="30"
                minlength="1"
                pattern="[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]{1,30}"
                title="Apellido debe tener un máximo de 30 caracteres, sin caracteres especiales"
              
                @input="paternalLastName =$filters.capitalizeWords(paternalLastName)"
              />
            </div>
            <span v-if="paternalLastNameError" class="text-xs text-red-500 w-full">
                Apellido paterno no válido 
            </span>
          </div>

          <div class="w-full ">
            <div>
              <label class="mt-2"> Apellido Materno: </label>
            </div>
            <div>
              <input
                id="input_mother_last_name"
                type="text"
                v-model="maternalLastName"
                class="w-full shadow-sm appearance-none border rounded py-2 px-3 text-grey-darker"
                maxlength="30"
                minlength="1"
                pattern="[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]{1,30}"
                title="Apellido debe tener un máximo de 30 caracteres, sin caracteres especiales"
                @input="maternalLastName =$filters.capitalizeWords(maternalLastName)"
              />
            </div>
            <span v-if="maternalLastNameError" class="text-xs text-red-500 w-full">
                Apellido no válido
            </span>
          </div>

          <div class="w-full">
            <div>
              <label class="mt-2"> Nombre*: </label>
            </div>
            <div>
              <input
                id="input_name_beneficiary"
                type="text"
                v-model="name"
                class="w-full shadow-sm appearance-none border rounded py-2 px-3 text-grey-darker"
                maxlength="30"
                minlength="2"
                pattern="[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]{1,30}"
                title="Nombre debe tener un máximo de 30 caracteres, sin caracteres especiales"
                @keyup="validateNameLentgth()"
                @input="name =$filters.capitalizeWords(name)"
              />
            </div>
          
            <span v-if="nameError" class="text-xs text-red-500 w-full">
                Nombre no válido 
            </span>
          </div>
          <div class="w-full lg:w-1/2 md:w-1/2 ">
            <div>
              <label class="mt-2 w-full"> Género*: </label>
            </div>

            <div>
              <b-form-group class="mt-2 w-full">
                <b-form-radio-group
                  id="btn-radios-gender"
                  v-model="gender"
                  :options="optionsGender"
                  buttons
                  button-variant="outline-primary"
                  size="sm"
                  name="radio-btn-stacked"
                >
                </b-form-radio-group>
              </b-form-group>
            </div>
          </div>
          <div class="w-full mt-2 sm:">
            <div>
              <label class="w-full"> Fecha de Nacimiento*: </label>
            </div>
            <div class="mt-2">
              <DatePicker
              id="input_birthdate"
              :startDate="new Date(1970, 1)"
              :minDate="new Date(1900, 1)"
              :maxDate="new Date()"
               v-model="birthday"
                :format="'dd/MM/yyyy'"
                placeholder="DD/MM/YYYY"
                textInput
                :yearRange="[1900, 2023]"
                cancelText="cancelar"
                selectText="seleccionar"
                locale="es"
                autoApply
              />
            </div>
          </div>
        </div>

        <div
          class="md:container lg:container xl:container lg:w-1/2 xl:w-1/2 lg:pl-24 xl:pl-48 flex flex-wrap"
        >
          <div class="w-full">
            <div>
              <label class="mb-2"> Porcentaje*: </label>
            </div>
            <div>
              <input
                id="input_percentage"
                type="number"
                v-model="percentage"
                class="w-1/2 lg:w-2/5 xl:w-2/5 shadow-sm appearance-none border rounded py-2 px-3 text-grey-darker"
                maxlength="3"
                minlength="1"
                v-maska="'###'"
                pattern="[0-9]{1,3}"
                title="Porcentaje debe tener un máximo de 3 caracteres, sin caracteres especiales"
              />
            </div>
          </div>

          <div class="w-full mt-5 mb-2">
            <button
              id="button_add"
              @click="verifyInputs()"
              type="button"
              class="w-1/2 d-flex justify-center items-center lg:w-2/5 xl:w-2/5 bg-orange-600 hover:bg-orange-700 text-sm md:text-base lg:text-base xl:text-base text-white font-bold py-2 rounded"
            >
              Agregar <mdicon name="plus" />
            </button>
          </div>

          <div
            class="flex flex-col md:flex-row"
            v-for="(beneficiary, index) in beneficiaryArray"
            v-bind:index="beneficiaryArray"
            :key="beneficiary.id"
          >
            <div class="w-2/3 lg:w-1/2 md:w-1/2 xl:w-1/2 items-center mt-3">
              <div>
                <label class=" mb-2">
                  {{
                    beneficiary.first_name.concat(
                      " ",
                      beneficiary.second_name
                    ) +
                    " " +
                    beneficiary.paternal_lastname +
                    " " +
                    (beneficiary.maternal_lastname
                      ? beneficiary.maternal_lastname
                      : "")
                  }}
                </label>
              </div>
              <div>
                <label class="mb-2 text-xs text-gray-600">
                  {{ beneficiary.kinship.label }}
                </label>
              </div>
            </div>

            <div class="w-1/3 inline-flex items-center mt-2">
              <div class="items-center">
                <label class="mb-2 text-3xl text-gray-500">
                  {{ beneficiary.percentage + "%" }}
                </label>
              </div>
              <div class="items-center pl-1">
                <button
                  id="button_edit"
                  @click="editBeneficiary(index)"
                  class="bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-2 border border-gray-400 rounded shadow"
                >
                  <svg
                    class="cursor-pointer text-xl h-3 w-3 fill-current text-gray-600"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                  >
                    <defs />
                    <path
                      d="M4 14a1 1 0 01.3-.7l11-11a1 1 0 011.4 0l3 3a1 1 0 010 1.4l-11 11a1 1 0 01-.7.3H5a1 1 0 01-1-1v-3z"
                      class="primary"
                    />
                    <rect
                      width="20"
                      height="2"
                      x="2"
                      y="20"
                      class="secondary"
                      rx="1"
                    />
                  </svg>
                </button>
              </div>
              <div class="items-center pl-1">
                <button
                  id="button_delete"
                  @click="removeArray(index)"
                  class="bg-white  hover:bg-gray-100 text-gray-800 font-semibold py-2 px-2 border border-gray-400 rounded shadow"
                >
                  <svg
                    class="cursor-pointer text-xl h-3 w-3 fill-current text-gray-600"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                  >
                    <defs />
                    <path
                      d="M5 5h14l-.89 15.12a2 2 0 01-2 1.88H7.9a2 2 0 01-2-1.88L5 5zm5 5a1 1 0 00-1 1v6a1 1 0 002 0v-6a1 1 0 00-1-1zm4 0a1 1 0 00-1 1v6a1 1 0 002 0v-6a1 1 0 00-1-1z"
                      class="primary"
                    />
                    <path
                      d="M8.59 4l1.7-1.7A1 1 0 0111 2h2a1 1 0 01.7.3L15.42 4H19a1 1 0 010 2H5a1 1 0 110-2h3.59z"
                      class="secondary"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="w-full p-2 text-center mt-3 mb-2">
          <button
            type="button"
            @click="goTo"
            class="w-full d-flex justify-center items-center mx-auto md:w-2/5 lg:w-2/5 xl:w-2/5 bg-orange-600 hover:bg-orange-700 text-2xl text-white font-bold py-2 px-6 rounded"
          >
            Siguiente <mdicon name="chevron-right" />
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import DatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import Swal from "sweetalert2";
import moment from "moment";
import { validateExistenceOnLastName } from '../helpers/existenceOfLastName';
//import { bn } from 'date-fns/locale';


export default {
  name: "AddAPBeneficiary",
  components:{DatePicker},
  data() {
    return {
      full_name: "",
      policy: null,
      paternalLastName: '',
      maternalLastName: '',
      name: '',
      paternalLastNameError: false,
      maternalLastNameError: false,
      existenceOfLastname: null,
      nameError: false,
      gender: "H",
      optionsGender: [
        { text: "Hombre", value: "H" },
        { text: "Mujer", value: "M" },
      ],
      birthday: null,
      percentage: null,
      beneficiaryArray: [],
      kinship: [
        {
          id: 1,
          kinship: "Esposo(a)",//"CÓNYUGUE",
        },
        {
          id: 2,
          kinship: "Hijo(a)",//"HIJOS",
        },
        {
          id: 3,
          kinship: "Padre/Madre",//"PADRES",
        },
        {
          id: 4,
          kinship: "Hermano(a)",//"HERMANOS",
        },
        {
          id: 5,
          kinship: "Abuelo(a)",//"ABUELOS",
        },
        {
          id: 6,
          kinship: "Tio(a)",//"TIOS",
        },
        {
          id: 7,
          kinship: "Concubino(a)",//"PAREJA",
        },
        {
          id: 8,
          kinship: "Sobrino(a)",//"SOBRINOS",
        },
      ],
      selectedKinship: [],
      errorKinship: false,
      beneficiaries: [],
      clickInAdd: false,
    };
  },
  mounted() {
    console.log("Policy:", JSON.parse(localStorage.getItem("policy")))
    this.verifyBeneficiariesInStorage();

    this.policy = JSON.parse(localStorage.getItem("policy"));
    if (localStorage.editBeneficiaryArray) {
      this.beneficiaryArray = JSON.parse(
        localStorage.getItem("editBeneficiaryArray")
      );
      var index = localStorage.getItem("editBeneficiaryArrayIndex");
      this.editBeneficiary(index);
    }
  },
  methods: {
    isValididTextLength(text){
      return !(text?.length > 2 && text?.length < 30)
    },
    validateNameLentgth(){
      this.nameError =  this.isValididTextLength(this.name)
    },
    verifyBeneficiariesInStorage(){
      console.log("this.getItemFromStorage beneficiaryArray: ", this.getItemFromStorage("beneficiaryArray"))
      if(!this.getItemFromStorage("beneficiaryArray")){
        return;
      }
      const beneficiaryArray = JSON.parse(this.getItemFromStorage("beneficiaryArray") )
      if(beneficiaryArray.length < 1){
        return false;
      }
      this.beneficiaryArray = beneficiaryArray
      

    },
    onlyLetter(text) {
      var letters = "^[a-zA-ZñÑáéíóúÁÉÍÓÚ ]+$";
      if(text.length > 0){
        if (text.match(letters)) {
          return true;
        } else {
          return false;
        }
      }
      return true;

    },
    onSubmit() {},
    goTo() {
      if (this.beneficiaryArray.length > 0) {
        this.verifyPercentageIs100();
        this.addBeneficiaries();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error.",
          text: "Favor de agregar al menos un beneficiario",
        });
      }
    },
    addBeneficiaries() {
      this.changeStructureBeneficiaries();
      this.policy.client.beneficiaries = this.beneficiaries;
      localStorage.setItem("policy", JSON.stringify(this.policy));
    },
    changeStructureBeneficiaries() {
      for (let i = 0; i < this.beneficiaryArray.length; i++) {
        this.beneficiaries.push({
          kinship: this.beneficiaryArray[i].kinship.label,
          paternal_lastname: this.beneficiaryArray[i].paternal_lastname,
          maternal_lastname: this.beneficiaryArray[i].maternal_lastname,
          first_name: this.beneficiaryArray[i].first_name,
          second_name: this.beneficiaryArray[i].second_name,
          percentage: this.beneficiaryArray[i].percentage,
          date_birth: this.beneficiaryArray[i].date_birth,
          gender: this.beneficiaryArray[i].gender,
        });
      }
    },
    editBeneficiary(index) {
      this.paternalLastName = this.beneficiaryArray[index].paternal_lastname;
      this.maternalLastName = this.beneficiaryArray[index].maternal_lastname;
      this.name = this.beneficiaryArray[index].first_name.concat(
        " ",
        this.beneficiaryArray[index].second_name
      );
      this.full_name = this.name
        .trim()
        .concat(" ", this.paternalLastName, " ", this.maternalLastName);
      this.percentage = this.beneficiaryArray[index].percentage;
      this.selectedKinship = this.beneficiaryArray[index].kinship;
      this.birthday = this.beneficiaryArray[index].date_birth;
      this.gender = this.beneficiaryArray[index].gender;
      this.beneficiaryArray.splice(index, 1);
    },
    verifyInputs() {
      if(this.kinshipSelected()){
        return;
      }
      if(!validateExistenceOnLastName(this.maternalLastName, this.paternalLastName)){
        console.log("Entro; ")
        Swal.fire({
          icon: "warning",
          title: "Campos vacíos",
          text: "Favor de capturar al menos un apellido.",
        });
        return;
      }
      this.clickInAdd = true;
      if (this.selectedKinship === null) {
        this.errorKinship = true;
      }
      if(this.paternalLastNameError || this.maternalLastNameError || this.nameError){
        Swal.fire({
          icon: "error",
          title: "Campos incorrectos",
          text: "Favor de llenar los campos correctamente.",
        });
        return;
      }
      if (
        this.paternalLastName == null ||
        this.name == null ||
        this.percentage == null ||
        this.errorKinship ||
        this.birthday == null
      ) {
        
        this.validateNameLentgth();
        Swal.fire({
          icon: "error",
          title: "Campos vacíos",
          text: "Todos los campos son requeridos.",
        });
      } else {
        if (
          this.onlyLetter(this.paternalLastName) &&
          this.onlyLetter(this.name)
        ) {
          if (this.maternalLastName != null) {
            if (!this.onlyLetter(this.maternalLastName)) {
              Swal.fire({
                icon: "error",
                title: "Error.",
                text: "Ingrese sólo letras en el campo Apellido Materno.",
              });
            }
          }
          if (this.percentage == 0) {
            Swal.fire({
              icon: "error",
              title: "Error.",
              text: "El valor debe ser mayor a cero.",
            });
          } else {
            if (this.percentage < 0) {
              Swal.fire({
                icon: "error",
                title: "Error.",
                text: "No se permiten valores negativos.",
              });
            } else {
              if (
                this.validateBirthday() &&
                this.compareNameTitularVsBeneficiary()
              ) {
                this.verifyPercentage();
              }
            }
          }
        } else {
          Swal.fire({
            icon: "error",
            title: "Error.",
            text: "Ingrese sólo letras en los campos Apellido Paterno y Nombre",
          });
        }
      }
    },
    verifyPercentage() {
      let sum = 0;
      for (let i = 0; i < this.beneficiaryArray.length; i++) {
        sum += Number(this.beneficiaryArray[i].percentage);
      }

      if (sum + Number(this.percentage) <= 100) {
        this.pushArray();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error.",
          text: "Se ha excedido del 100% del porcentaje",
        });
      }
    },
    verifyPercentageIs100() {
      let sum = 0;
      for (let i = 0; i < this.beneficiaryArray.length; i++) {
        sum += Number(this.beneficiaryArray[i].percentage);
      }
      if (sum /*+ Number(this.percentage)*/ == 100) {
        
        localStorage.removeItem("editBeneficiaryArray");
        localStorage.removeItem("editBeneficiaryArrayIndex");
        this.$router.push({ name: "carga-identificacion" });
      } else {
        Swal.fire({
          icon: "info",
          title: "AVISO",
          text: "Agregue beneficiarios hasta que se complete el 100%",
        });
      }
    },
    validateBirthday() {
      var today = moment().format("dd/MM/yyyy");
      if (moment(this.birthday).isAfter(today)) {
        Swal.fire(
          "Fecha no admitida",
          "La fecha de nacimiento no puede ser mayor a la fecha actual.",
          "info"
        );
        return false;
      }
      let birthdayOwner = localStorage.birthdayOwner;
      let kinship = this.selectedKinship.label;
      let birthBeneficiary = moment(this.birthday).format("YYYY/MM/DD");
      let birthOwner = moment(birthdayOwner).format("YYYY/MM/DD");
      let ageOwner = this.getAge(birthOwner);
      let ageBeneficiary = this.getAge(birthBeneficiary);

      if (kinship == "Padre/Madre") {
        if ((ageOwner+12) > ageBeneficiary) {
          Swal.fire(
            "Edad no admitida",
            "La edad del beneficiario Padre no puede ser menor a la edad del titular.",
            "info"
          );
          return false;
        }
      }
      if (kinship == "Hijo(a)") {
        if ((ageOwner-12) < ageBeneficiary) {
          Swal.fire(
            "Edad no admitida",
            "La edad del beneficiario hijo no puede ser mayor a la edad del titular.",
            "info"
          );
          return false;
        }
      }
      return true;
    },
    pushArray() {
      let array = this.name.split(" ");
      let secondName = "";
      for (var i = 1; i < array.length; i++) {
        secondName += array[i].replace(/^\w/, (c) => c.toUpperCase()) + " ";
      }
      this.beneficiaryArray.push({
        kinship: this.selectedKinship,
        paternal_lastname: this.paternalLastName,
        maternal_lastname: this.maternalLastName,
        first_name: array[0],
        second_name: secondName.substring(0, secondName.length - 1),
        percentage: Number(this.percentage),
        date_birth: this.birthday,
        gender: this.gender,
      });

      localStorage.setItem(
          "beneficiaryArray",
          JSON.stringify(this.beneficiaryArray)
        );
      this.clearInputs();
    },
    setItemFromStorage(itemName, item){
      localStorage.setItem(itemName,JSON.stringify(item));
    },
    getItemFromStorage(item){
      return localStorage.getItem(item) || '[]';
    },
    removeArray(index) {
      
      Swal.fire({
        title: '¿Estás seguro de querer eliminar?',
        text: "No podrás revertirlo!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#E0E0E0',
        cancelButtonColor: '#dd6b33',
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          let beneficiariesStorage = JSON.parse(this.getItemFromStorage('beneficiaryArray'));

          beneficiariesStorage.splice(index, 1);
          console.log("beneficiariesStorage: ",beneficiariesStorage)
          this.setItemFromStorage('beneficiaryArray', beneficiariesStorage)

          this.beneficiaryArray.splice(index, 1);
          Swal.fire(
            'Eliminado correctamente!',
            'Se ha eliminado el beneficiario.',
            'success'
          )
        }
      })
    },
    clearInputs() {
      this.paternalLastName = '';
      this.maternalLastName = '';
      this.name = '';
      this.percentage = null;
      this.selectedKinship = null;
      this.gender = "H";
      this.birthday = null;
    },
    compareNameTitularVsBeneficiary() {
      let client = this.policy.client;
      let nameTitular = client.first_name.concat(" ", client.second_name);
      nameTitular = nameTitular
        .trim()
        .concat(" ", client.paternal_lastname, " ", client.maternal_lastname);

      let nameBeneficiary =
        this.name.trim() +
        " " +
        this.paternalLastName.trim() +
        " " +
        this.maternalLastName.trim();
      if (
        nameTitular.trim().toLowerCase() == nameBeneficiary.trim().toLowerCase()
      ) {
        Swal.fire({
          icon: "error",
          title: "Nombre incorrecto",
          text:
            "El nombre del titular no puede ser igual al nombre del beneficiario",
        });
        return false;
      }
      return true;
    },
    kinshipSelected() {
      if (this.selectedKinship?.label?.length >= 0) {
        this.errorKinship = false;
      }
      else {
        this.errorKinship = true;
      }
    
      return this.errorKinship;
    },
    getAge(_birthdate) {
      var birthdate = new Date(_birthdate)
      console.log("birthdate",birthdate)
      const today = new Date();
      const age = today.getFullYear() - birthdate.getFullYear() - 
                (today.getMonth() < birthdate.getMonth() || 
                (today.getMonth() === birthdate.getMonth() && today.getDate() < birthdate.getDate()));
      return age;
    }
  },
  watch: {},
  computed: {
    selectKinshipOptions() {
      let maritalStatus = localStorage.maritalStatus;
      let filterArray = this.kinship.filter(function (element) {
        if (
          maritalStatus == "Soltero(a)" ||
          maritalStatus == "Divorciado(a)" ||
          maritalStatus == "Viudo(a)"
        ) {
          return (
            element.id == 2 ||
            element.id == 3 ||
            element.id == 4 ||
            element.id == 5 ||
            element.id == 6 ||
            element.id == 8
          );
        }
        if (maritalStatus == "Casado(a)" || maritalStatus == "Concubinato") {
          return (
            element.id == 1 ||
            element.id == 2 ||
            element.id == 3 ||
            element.id == 4 ||
            element.id == 5 ||
            element.id == 6 ||
            element.id == 7 ||
            element.id == 8
          );
        }
      });
      return filterArray.map((kinship) => ({
        label: kinship.kinship,
        value: kinship.id,
      }));
    },
  },
};
</script>

<style scoped>
.box-shadow {
  border: 1px;
  padding: 10px;
  box-shadow: 2px 10px 8px #888888;
}
</style>